export const REPORTMISSINGRATE_SEARCH = 'REPORTMISSINGRATE_SEARCH';
export const REPORTMISSINGRATE_PAGE = 'REPORTMISSINGRATE_PAGE';
export const REPORTMISSINGRATE_YEAR = 'REPORTMISSINGRATE_YEAR';
export const REPORTMISSINGRATE_MONTH = 'REPORTMISSINGRATE_MONTH';
